import { render, staticRenderFns } from "./viewpdf.vue?vue&type=template&id=2a6ae56a&scoped=true&"
import script from "./viewpdf.vue?vue&type=script&lang=js&"
export * from "./viewpdf.vue?vue&type=script&lang=js&"
import style0 from "./viewpdf.vue?vue&type=style&index=0&id=2a6ae56a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ae56a",
  null
  
)

export default component.exports